$(document).ready(function () {
    const slider = $('.entertainment__slider.entertainment__slider--slides-show-tree');

    if (slider.length > 0) {
        slider.slick({
            slidesToShow: 3,
            appendArrows: $('.entertainment__nav'),
            arrows: true,
            infinite: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    }
                },
            ]
        });
    }
});
